export default __webpack_public_path__ + "static/media/934.b34879da.png";